<template>
  <div>Loading...</div>
</template>

<script setup lang="ts">
import { usePartyStore } from "@/stores/parties";
import { useRepsStore, useUserStore } from "@/stores/user";
import api from "@virgodev/bazaar/functions/api";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  partyId: number;
}>();
const parties = usePartyStore();
const reps = useRepsStore();
const user = useUserStore();
const router = useRouter();

onMounted(async () => {
  const response = await api({
    url: `https://paparazziaccessories.com/api/parties/${props.partyId}/`,
  });
  if (response.ok) {
    router.push({
      name: "consultant-parties",
      params: { consultantId: response.body.rep_number },
    });
  } else if (user.props.customer_rep) {
    router.push({
      name: "consultant-parties",
      params: { consultantId: user.props.customer_rep },
    });
  } else {
    router.push({ name: "shop" });
  }
});
</script>

<style scoped></style>
